import React from 'react'
import util from "../../../../../../../utils/es5Utils";
import _ from "underscore";
export const cameraIcon = "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 68 64' fill='none' stroke='white' stroke-width='5' stroke-linejoin='round' stroke-linecap='round'><path d='M6 14 h14 l4-7 h16 l4 7 h14 a6 6 0 0 1 6 6 v30 a6 6 0 0 1 -6 6 H6 a6 6 0 0 1 -6 -6 V20 a6 6 0 0 1 6 -6z'/><circle cx='32' cy='34' r='10' /></svg>";


export default function Camera(props) {
    const widgets = util.widgetsOfType(props.context, 'camera');
    const newProps = Object.assign({}, props, { widgets });
    const childComponents = _.values(props.childComponents).map((Component, id) => <Component.component {...newProps} key={id} />);

    if (widgets.length > 0 && childComponents.length > 0) {
        return [<label text={'Camera'} />, ...childComponents]
    }

    return null;
}
